module.exports = __webpack_public_path__ + "img/notPr_lost.b906cbd6.png";